import { Box } from "@mui/material";
import { pagePaddingSx } from "../../constants/pageStyles";

/**
 * Sayfa içeriği için ortak sarmalayıcı.
 * Mobil ile hizalı responsive padding sağlar; panel yapısını (drawer/appbar) değiştirmez.
 */
const PageContainer = ({ children, sx, ...props }) => (
  <Box
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      ...pagePaddingSx,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);

export default PageContainer;
